import * as React from 'react'
import * as styles from './FiltersNav.module.scss'
import * as cn from 'classnames'
import { TabHeading } from '@amzn/dvui/dist/TabHeading'
import '../utils/polyfills/findIndex'
import checkUrlType from '../utils/url-type-checker'
import { StorefrontFacetedNav, OfferFilterValue, pushState, replaceState } from 'DVWebNodeUtils';

interface FiltersNavProps extends StorefrontFacetedNav {
  hasExperimentalFilters: boolean
  loadFilteredContent: Function
}

interface OfferFilterValueSnapshot {
  i: number
  apiUrl: string
  url: string
}

class FiltersNav extends React.Component<FiltersNavProps> {

  generateHistoryChangeHandler(i: number, data: OfferFilterValue, currentData: OfferFilterValueSnapshot) {
    return () => {
      if (window.history) {
        if (!window.history.state) {
          replaceState(currentData, null, currentData.url)
        }
        if (!currentData || currentData.i !== i) {
          pushState({ i, apiUrl: data.apiUrl }, document.title, data.url)
        }
      } else {
        // Note: this statement reloads the page in lt IE10.
        // But it is required to maintain back button state
        window.location.assign(data.url)
      }
    }
  }

  generateClickHandler(i: number, data: OfferFilterValue, currentData: OfferFilterValueSnapshot) {
    return (e: React.MouseEvent<HTMLAnchorElement>) => {
      if (this.props.hasExperimentalFilters) {
        return
      }
      e.preventDefault()
      this.props.loadFilteredContent(i, data.apiUrl)
        .then(this.generateHistoryChangeHandler(i, data, currentData))
    }
  }

  getCurrentData() {
    const currentFilterId = this.props.filter.values.findIndex(filter => filter.isCurrentlyApplied)
    if (currentFilterId === -1 || !this.props.filter.values[currentFilterId] ||
      typeof window === 'undefined' || !window.location) {
      return { i: null, apiUrl: null, url: null }
    }
    const currentFilter = this.props.filter.values[currentFilterId]
    const currentData = {
      i: currentFilterId,
      apiUrl: currentFilter.apiUrl,
      url: window.location.href
    }
    return currentData
  }

  generateTabLinks() {
    if (!this.props || !this.props.filter || !this.props.filter.values) {
      return null
    }
    const currentData = this.getCurrentData()
    return this.props.filter.values.map((data, i) => ({
      active: data.isCurrentlyApplied,
      content: (<a
        href={checkUrlType(data.url, 'FiltersNav')}
        className={cn('tst-filtersnav-item', `tst-filtersnav-${data.name}`,
          styles.item, { [styles.active]: data.isCurrentlyApplied })}
        onClick={this.generateClickHandler(i, data, currentData)}>
        {data.text}
      </a>),
      attrs: {}
    }))
  }

  render() {
    const tabLinks = this.generateTabLinks()
    if (!tabLinks) {
      return null
    }
    return (
      <div className={cn('tst-filtersnav', styles.FiltersNav)}>
        <TabHeading tabLinks={tabLinks} />
      </div>
    )
  }
}

export default FiltersNav
